module.exports = __webpack_public_path__ + "static/img/united-states.0b810c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/flag/united-states.png
// module id = +d+C
// module chunks = 1